export default __webpack_public_path__ + "static/media/pin.243792ae.svg";